// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_n6I","col":"styles_col__2vbdu"};